import type {
  CompanyFollower,
  CompanyFollowerRequest,
  FollowCompany,
  FollowCompanyRequest,
} from "@/modules/companies/client/api/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

export const COMPANY_FOLLOWER_QUERY_KEY = "companies::company::follower"
export const COMPANY_FOLLOWER_ENDPOINT = "/jobteaser.company.follow.v1alpha1/FollowService/CompanyFollower"
export const FOLLOW_COMPANY_ENDPOINT = "/jobteaser.company.follow.v1alpha1/FollowService/Follow"
export const UNFOLLOW_COMPANY_ENDPOINT = "/jobteaser.company.follow.v1alpha1/FollowService/Unfollow"

export const getCompanyFollower = async ({
  nextRequest,
  ...restParams
}: CompanyFollowerRequest): Promise<CompanyFollower> => {
  return fetcher(COMPANY_FOLLOWER_ENDPOINT, {
    nextRequest,
    requestInit: {
      body: JSON.stringify(restParams),
      method: "POST",
    },
    serviceDomain: "GATEWAY_API",
  })
    .then(getResultFromResponse<CompanyFollower>({ transformResult: toCamelCaseKeys<CompanyFollower> }))
    .catch(handleFetchError(COMPANY_FOLLOWER_ENDPOINT))
}

export const setFollowCompanyStatus = async ({
  follow,
  nextRequest,
  ...restParams
}: FollowCompanyRequest): Promise<FollowCompany> => {
  const path = follow ? FOLLOW_COMPANY_ENDPOINT : UNFOLLOW_COMPANY_ENDPOINT

  return fetcher(path, {
    nextRequest,
    requestInit: {
      body: JSON.stringify(restParams),
      method: "POST",
    },
    serviceDomain: "GATEWAY_API",
  })
    .then(getResultFromResponse<FollowCompany>({ transformResult: toCamelCaseKeys<FollowCompany> }))
    .catch(handleFetchError(path, restParams))
}
